import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { setApproveSaleInvoice } from '../services/setApproveSaleInvoice';


export const approveSaleInvoice = createAsyncThunk(
  'saleInvoices/approveSaleInvoice',
  async (params, { getState, dispatch }) => {
    console.log('params', params);
    const { saleInvoiceId } = params;

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await setApproveSaleInvoice(selectedProjectId, saleInvoiceId);
    console.log('response', response);
    return response;
  }
);
